export default "__VITE_ASSET__DfDw7hsj__"